import React, { Fragment, useState } from "react";
import Translator from "Languages/Utility/Translator";
import Input from "Components/Input/Input";
import { useDispatch, useSelector } from "react-redux";
import { authNewPassword } from "Stores/actions";
import showNotify from "Helpers/Notify";
import PasswordIcon from "Assets/svg/icon/PasswordIcon";
import AuthHeader from "../components/AuthHeader";
import { useSetState } from "Helpers/Hooks";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import MuiButton from "Components/MuiButton/MuiButton";
import { useEffect } from "react";
import { useTranslation } from 'react-i18next';

function NewPassword() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [password, setPassword] = useState();
  const [formValid, setFormValid] = useState(false);
  const passwordValidation = { required: true };
  const [controls, setControls] = useSetState({
    changePasswordUsers: {
      type: "select",
      selectItems: [],
      value:null ,
      validation: null,
    }
  });
  
  const { userId, numberCode,usersForget } = useSelector((state) => ({
    userId: state.auth.userId,
    numberCode: state.auth.numberCode,
    usersForget:state.auth.usersForget
  }));

  useEffect(() => {
    (async () => {
      if (usersForget) {
        const items = await  usersForget.map((m) => {
          return {
            ...m,
            value: m.Id,
            label: m.Name,
          };
        });
        setControls({ changePasswordUsers: {
          selectItems: items,
          value: items[0]
        } });
      }
    })()
  }, [usersForget]);
  const onNewPassword = async (e) => {
    e.preventDefault();
    if (formValid) {
      try {
        const data = {
          Code: numberCode,
          Type: 2,
          Value: userId,
          PasswordNew: password,
          Id:controls["changePasswordUsers"].value.value
        };
        await dispatch(authNewPassword(data));
      } catch (err) {
      console.error('[catch error]', err)
    }
    } else {
      showNotify({ 
        text: t('checkAllFields'),
        customClass: "error"
      });
    }
  };

  const setValue = (name, value, validation) => {
    setPassword(value);
    setFormValid(validation);
  };
  const autoCompleteHandler = async (e, value) => {

    const controlName = e.target.id.split("-")[0];

    setControls({ [controlName]: { value: value } });
  }
  return (
    <Fragment>
      <AuthHeader
        title={t('newPassword')}
        description={t('enterNewPassword')}
      />
      <form onSubmit={onNewPassword} className="pt-5">
        <div className="mt-2 mb-3 text-left">

          <MuiAutoComplete
            options={controls["changePasswordUsers"].selectItems}
            label={<Translator id={"users"} />}
            value={controls["changePasswordUsers"].value}
            id={"changePasswordUsers"}
            onChange={autoCompleteHandler}
          />
        </div>

          <div className="authForm ">
          <Input
            setValue={setValue}
            value={password}
            name="password"
            className="newPssswordField"
            label={<Translator id="password" />}
            icon={<PasswordIcon />}
            type="password"
            validation={passwordValidation}
          />

        </div>
        <div className="d-flex justify-content-center my-3">
          <MuiButton
            color="primary"
            type="submit"
            className="w-100"
            title={<Translator id="button_register_password" />}
          />
        </div>
      </form>
    </Fragment>
  );
}

export default NewPassword;
